/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React, { CSSProperties, useEffect, useState } from "react";
import { SpinnerLoading } from "../utils/SpinnerLoading";
import { ErrorMessage } from "../utils/ErrorMessage";
import { fetchRecords } from "../utils/AppUtil";
import { Link } from "react-router-dom";

class Funeral {
    deceasedId: string;
    burialDate: string;
    burialTime: string;
    deceased: string;
    cemeteryName: string;
    constructor(deceasedId: string, burialDate: string, burialTime: string, deceased: string, cemeteryName: string) {
        this.deceasedId = deceasedId;
        this.burialDate = burialDate;
        this.burialTime = burialTime;
        this.deceased = deceased;
        this.cemeteryName = cemeteryName; 
    }
}

type UpcomingFuneralsProps = {
    endpoint: string;
    recordCount: number;
}

export const UpcomingFunerals: React.FC<UpcomingFuneralsProps> = (props) => {
    
    const [records, setRecords] = useState<Funeral[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [httpError, setHttpError] = useState(null);
    const [endpoint, setEndpoint] = useState(`${props.endpoint}?count=${props.recordCount}`);

    const desktopStyle: CSSProperties = {
        height: 'calc(100% - 604px)'
    }

    // Do not change this or put any additional code in here without checking with
    // the team first.
    useEffect(() => {

        fetchRecords(endpoint, processData)
        .catch((error) => {
            setIsLoading(false);
            setHttpError(error.message);
        });

    }, [endpoint]);

    // You may edit this function to manipulate the way your code is processed.
    const processData = (responseJson: any) => { // Do not edit these parameters, just the content of this function.
        const recordData: Funeral[] = [];
    
        for(const key in responseJson) {
            const record: any = responseJson[key];
            const deceasedId = record["deceasedId"];
            const burialDate: string = record["burialDateDisplay"];
            const burialTime: string = record["burialTimeDisplay"];
            const deceased: string = (record["firstName"] ? record["firstName"] : " ") + " " + (record["lastName"] ? record["lastName"] : "");
            const cemeteryName: string = record["cemeteryName"];

            recordData.push(new Funeral(deceasedId, burialDate, burialTime, deceased, cemeteryName));
        }
        
        setRecords(recordData);
        setIsLoading(false);
    }

    if(isLoading) {
        return(
            <SpinnerLoading />
        )
    }

    if(httpError) {
        return(
            <ErrorMessage error={httpError} />
        )
    }

    const result: React.ReactElement[] = [];

    records.forEach((funeral, index) => {
        result.push(
            <tr key={index}>
                <td className="jc-txt-body fs-6 fw-bold table-mobile-left">
                <Link to={'/deceased/' + funeral.deceasedId} className="jc-txt-blue">{funeral.deceased}</Link>
                </td>
                <td className="jc-txt-body fs-7 align-end table-mobile-right" style={{whiteSpace: "nowrap"}}>
                    <span>{funeral.burialDate ? funeral.burialDate: "To be confirmed"}</span>
                    <span>{funeral.burialTime ? " • " + funeral.burialTime : ""}</span>
                </td>
            </tr>
        )
    });

    let multipleRecords = false;
    if (records.length > 3) {
        multipleRecords = true;
    }
    

    return (
        <div className="card card-upcoming-funerals jc-border-12" style={(window.innerWidth > 991) ? desktopStyle : undefined}>
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Upcoming Funerals</p>
            </div>

            <div className="card-body p-0">
                <div className="table-upcoming-funerals" style={multipleRecords ? {height : "202px"} : {height: "calc(100% - 24px)"}}>
                    <table className="table table-striped mb-0">
                        <tbody>
                            {result}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}